import React from 'react'
import { Layout } from 'antd'

const { Footer } = Layout

export default function Index() {

    return (
        <Footer>Copyright © {new Date().getFullYear()} <a href="http://noapp.ir/" title="!APP" target="_blank">!APP</a> {process.env.REACT_APP_VERSION}</Footer>
    )
}
